<template>
  <ElForm label-position="top" class="app-videoshots-form">
    <ElFormItem
      :label="$t('APP.MEDIA.VIDEO_SHOTS_URL_FA')"
      :error="errors.videoshotFa"
    >
      <ElInput
        :value="videoshotFa"
        placeholder="https://www.aparat.com/v/SGcaj"
        dir="ltr"
        class="text-latin"
        @input="$emit('update:videoshot-fa', $event)"
      />
    </ElFormItem>

    <OptionalFormItem
      :initial_visibility="Boolean(videoshotEn)"
      :label="$t('APP.MEDIA.VIDEO_SHOTS_URL_EN')"
      :error="errors.videoshotEn"
      @remove="$emit('update:videoshot-en', '')"
    >
      <ElInput
        :value="videoshotEn"
        placeholder="https://www.aparat.com/v/SGcaj"
        dir="ltr"
        class="text-latin"
        @input="$emit('update:videoshot-en', $event)"
      />
    </OptionalFormItem>
  </ElForm>
</template>

<script>
import OptionalFormItem from '@/components/common/OptionalFormItem.vue';

export default {
  name: 'AppVideoshotsForm',
  components: { OptionalFormItem },
  props: {
    videoshotFa: {
      type: String,
      default: '',
    },
    videoshotEn: {
      type: String,
      default: '',
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
